import BlogSlider from "@/components/common/BlogSlider";
import { WhyChooseOurServices } from "@/components/data-solution/common/WhyChooseOurServices";
import CustomizedSolutions from "@/components/data-solution/web-scraping-api/CustomizedSolutions";
import Hero from "@/components/data-solution/web-scraping-api/Hero";
import Layout from "@/components/layout/Layout";
import { cmsUrl } from "@/utils/helper";
import axios from "axios";
import { WEB_API_CARD_DATA } from "const/data-solution";

const webScrapingApi = ({ data }) => (
  <Layout
    canonicalLink="https://ultroneous.com/web-scraping-api"
    description="Elevate your data strategy with ultroNeous, offering the best in web scraping API and data mining solutions. Optimize extraction accuracy and efficiency today."
    title="Best Web Scraping API & Data Mining Solution | ultroNeous"
  >
    <Hero />
    <WhyChooseOurServices
      subTitle="Why Choose our Web Scraping API Services?"
      subTitleClass="text-white text-center text-4xl md:text-6xl mb-0 pb-10 md:pb-24 md:leading-tight"
      data={WEB_API_CARD_DATA}
      buttonName="Get Free Sample Data"
      id="DataScraping-enterprise"
    />
    <CustomizedSolutions />
    <div className="py-20 md:py-24">
      {data.blog.length > 0 ? <BlogSlider list={data.blog} /> :<></>}
    </div>
  </Layout>
);

export async function getServerSideProps() {
  let blogData;
  try {
    blogData = await axios
      .get(`${cmsUrl}/wp-json/wp/v2/posts?categories=1`)
      .then((getblog) => getblog);
  } catch (error) {
    blogData = { data: [] };
  }

  return {
    props: {
      data: {
        blog: blogData ? blogData?.data : [],
      },
    },
  };
}

export default webScrapingApi;
